/**
 * @file: ReportShareMethod.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ReportShareMethod {
  WeixinMiniprogram = 1,
  SmsLink = 2,
  WecomMiniprogram = 3,
  AppLink = 4,
  Other = 9,
}

export const ReportShareMethodValueSet = new Set([
  ReportShareMethod.WeixinMiniprogram,
  ReportShareMethod.SmsLink,
  ReportShareMethod.WecomMiniprogram,
  ReportShareMethod.AppLink,
  ReportShareMethod.Other,
]);
